module.exports = __webpack_public_path__ + "img/1501549312.9d11bf97.jpg";